import { View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";

export function AllServicesEmptyState({ query }: { query?: string }) {
  return (
    <View className="flex flex-1 flex-col items-center justify-center py-12">
      <Typography
        variant="label-lg"
        color="foreground-intermediate"
        className="text-center"
      >
        No services found
      </Typography>
      {query ? (
        <Typography
          variant="body-md"
          color="foreground-intermediate"
          className="mt-2 text-center"
        >
          Try a different search term
        </Typography>
      ) : null}
    </View>
  );
}
